// opervex-frontend/src/pages/Reports/StockSerialDays.js

import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import DynamicReport from "../../components/DynamicReport";
import useOpervex from "../../hooks/useOpervex";

const StockSerialDays = () => {
  const [schema, setSchema] = useState(null);
  const OpervexAPI = useOpervex();

  useEffect(() => {
    const loadSchema = async () => {
      const result = await OpervexAPI.Report.StockSerialDays.schema();
      setSchema(result);
    };

    loadSchema();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!schema)
    return (
      <Container fluid className="text-center mt-5">
        <span>Carregando relatório...</span>
      </Container>
    );

  return (
    <>
      <h1 className="fw-light text-center">Relatório de Movimentação - Serial - Dias em Estoque</h1>

      <DynamicReport reportName={"reportStockSerialDays"} urlData={"/Report/StockSerialDays"} schema={schema} />
    </>
  );
};

export default StockSerialDays;
